export class MoovInstanceExecutionHistoryDTO{
    public id!: number;
    public customerId!: number;
    public moovConfigurationId!: number;
    public configurationStatus!: number;
    public sourceFileName!: string;
    public sourceFileId!: number;
    public sourceFilePurgeAfter!: string;
    public sourceFilePurgedAt!: string;
    public status!: number;
    public completedAt!: string;
    public added!: string;
    public updated!: string;
    public addedByUserId!: number;
    public waitingForApprovalByUserId!: number; //0=no approval expected
    public nextStepId!: number;
    public nextStep!: string;
    public nextStepDueAt!: string;
    public currentStepsStatus!: any;
    public metaDataOutputList!: string[];

}